import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

// MySQL DB names can't contain / \ or .
// http://stackoverflow.com/a/9537932/393274

// We're disallowing a bunch of characters here that can be in file paths
// which I think may also cause problems in MySQL
// http://stackoverflow.com/questions/1976007/what-characters-are-forbidden-in-windows-and-linux-directory-names
// #36904 allowing hyphens though since SQL Server is fine with them. Really we
// should branch on the database type when running these checks, but that's a
// task for another day
var invalidCharacters = ['.', '/', '\\', '\0', '*', '"', /* '-', */ '[', ']', ':', ';', '|', '=', ',', '<', '>', '?' ]

function databaseNameValidator(val) {
	if (_.isEmpty(val)) {
		return
	}

	for (var i=0; i<val.length; i++) {
		var c = val.charAt(i)
		for (var j=0; j<invalidCharacters.length; j++) {
			if (c === invalidCharacters[j]) {
				return i18n.get('admin.databaseConnections.all.databaseName.invalid', invalidCharacters.join(' '))
			}
		}
	}

	if ('0123456789'.indexOf(val.charAt(0)) !== -1) {
		return i18n.get('admin.databaseConnections.all.databaseName.cannotStartWithNumber')
	}
}

export default databaseNameValidator

databaseNameValidator.__filename__ = 'components/validators/database-name-validator.js'
